// extracted by mini-css-extract-plugin
export default {"dhcpValueTypeField":"DhcpOptionFormFields_dhcpValueTypeField__Dni1I"};